import { SortDirection } from '../../sortable-filter';

export class ReportSorting {
    sortField: string;
    sortDir: SortDirection;
}
